import { render, staticRenderFns } from "./DocumentPendingDataTable.vue?vue&type=template&id=f61ff05a&scoped=true"
import script from "./DocumentPendingDataTable.vue?vue&type=script&lang=js"
export * from "./DocumentPendingDataTable.vue?vue&type=script&lang=js"
import style0 from "./DocumentPendingDataTable.vue?vue&type=style&index=0&id=f61ff05a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f61ff05a",
  null
  
)

export default component.exports